import { PowerOff } from 'lucide-react';

import { Badge } from '@/components/ui/badge';

export function DisabledAccountBadge(): JSX.Element {
  return (
    <Badge variant="destructive" data-testid="disabled-account-badge">
      <PowerOff className="mr-1 h-3 w-3" />
      Disabled
    </Badge>
  );
}
